import React from 'react';
import Certificates from './Certificates';

export default function About() {
  return (
    <section id="omne" className="bg-light px-4 sm:px-6 lg:px-8 py-20 scroll-mt-16">
      <div className="flex md:flex-row flex-col items-center gap-12 mx-auto max-w-7xl">
        <div className="md:w-1/2 md:text-left text-center">
          <h2 className="mb-4 font-extrabold text-dark text-3xl sm:text-4xl">
            Martin Rygl
          </h2>
          <p className="text-secondary text-base sm:text-lg leading-relaxed">
            Jmenuji se Martin Rygl a více než 5 let pomáhám lidem budovat finanční jistotu, plánovat budoucnost a dosahovat jejich cílů.
Věřím, že každý si zaslouží přehledné a férové poradenství – ať už řešíte pojištění, investice, bydlení nebo zajištění na stáří.

<br></br>
Ke každému klientovi přistupuji individuálně, s důrazem na kvalitu, etiku a dlouhodobé partnerství. Mým cílem je vždy najít to nejlepší řešení na míru Vašim potřebám.</p>
        </div>

        <div className="flex justify-center w-full md:w-1/2">
          <div className="relative shadow-lg rounded-xl w-full max-w-md h-64 md:h-96 overflow-hidden">
            <img
              src="/assets/rygl.jpg"
              alt="Poradce"
              className=""
              /*w-full h-full object-cover */
            />
          </div>
        </div>
      </div>

      <div className="mx-auto mt-20 max-w-7xl text-center">
        <h3 className="mb-8 font-bold text-dark text-2xl sm:text-3xl">
          Certifikáty
        </h3>
        <Certificates />
      </div>
    </section>
  );
}
